/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path.fill {
    fill: ${theme.color.modalgray};
  }
`

export default class SpeedIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" css={Color}>
        <g id="sdgasgf" transform="translate(-2890 -2598)">
          <rect id="사각형_3051" data-name="사각형 3051" width="12" height="12" transform="translate(2890 2598)" fill="#ff23ff" opacity="0"/>
          <path id="패스_5301" className="fill" data-name="패스 5301" d="M1672.646-331.688a.4.4,0,0,0-.36-.227h-1.92l1.445-4.08a.4.4,0,0,0-.183-.483.4.4,0,0,0-.507.1l-4.684,5.876a.4.4,0,0,0-.048.423.4.4,0,0,0,.36.226h1.988l-1.447,3.947a.4.4,0,0,0,.18.486.394.394,0,0,0,.2.052.4.4,0,0,0,.312-.15l4.62-5.747A.4.4,0,0,0,1672.646-331.688Z" transform="translate(1226.483 2934.948)" fill="#929292"/>
        </g>
      </svg>
    )
  }
}
